import state from './moduleBrandState.js'
import mutations from './moduleBrandMutations.js'
import actions from './moduleBrandActions.js'
import getters from './moduleBrandGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
